<template>
  <div class="button-container" @click="changeSlide">
    <div class="progress-bar" :class="{'progress-bar-100' : currentSlide}">&nbsp;</div>
  </div>
</template>

<script>

export default {
  name: 'TestimonialCarouselButton',
  props: {
    id: Number,
    currentSlide: Boolean,
  },
  methods: {
    changeSlide() {
      this.$emit('changeSlide', this.id);
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .button-container {
    border-radius: 5px;
    width: 23%;
    height: 10px;
    background-color: $light-grey-background;
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
  }

  .progress-bar {
    background-color: $awards;
    border-radius: 5px;
    width: 0;
    height: 10px;
  }

  .progress-bar-100 {
    width: 100%;
    margin: 0;
    animation: width linear 12s;
    animation-name: slidein;
  }

  @keyframes slidein {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/carousels/testimonialCarousel/testimonialCarouselButton.vue